import script from "./RepunchDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./RepunchDialog.vue?vue&type=script&lang=ts&setup=true"

import "./RepunchDialog.vue?vue&type=style&index=0&id=c3a3cccc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ayaka_kitahara\\source\\pcare\\src\\ui-iikum\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3a3cccc"]])

export default __exports__